import { Timeline, Typography } from 'antd';
import React from 'react';
import Empty from '@/components/QuietEmpty';
import { formatCrmDate } from '@/modules/zy-crm/utils/display';

const { Paragraph, Text } = Typography;

export type OperationLogItem = {
  key: string;
  title: string;
  description?: string;
  time?: string | null;
  operatorUserUuid?: string;
  operatorName?: string;
};

export type OperationLogPage = {
  list: Array<OperationLogItem | Record<string, any>>;
  total: number;
};

export type OperationLogInput =
  | OperationLogPage
  | OperationLogItem[]
  | Array<Record<string, any>>;

const normalizeOperationLogItem = (
  item: Record<string, any>,
  index: number,
) => ({
  key: String(item.key || item.uuid || item.id || index),
  title: String(
    item.title ||
      item.operationName ||
      item.actionName ||
      item.action ||
      '操作记录',
  ),
  description:
    typeof item.description === 'string'
      ? item.description
      : typeof item.remark === 'string'
        ? item.remark
        : undefined,
  time: item.time || item.createdAt || item.operationTime,
  operatorUserUuid: item.operatorUserUuid || item.userUuid || item.operatorUuid,
  operatorName: item.operatorName || item.userName,
});

const normalizeOperationLogPage = (
  items?: OperationLogInput,
): OperationLogPage => {
  if (!items) {
    return { list: [], total: 0 };
  }
  if (Array.isArray(items)) {
    const list = items.map((item, index) =>
      normalizeOperationLogItem(item as Record<string, any>, index),
    );
    return { list, total: list.length };
  }
  return {
    ...items,
    list: (items.list || []).map((item, index) =>
      normalizeOperationLogItem(item as Record<string, any>, index),
    ),
  };
};

export function DetailOperationLogs({
  title,
  items,
  emptyText = '暂无操作记录',
  memberNameMap,
}: {
  title: string;
  items?: OperationLogInput;
  emptyText?: string;
  memberNameMap?: Record<string, string>;
}) {
  const page = normalizeOperationLogPage(items);
  return (
    <>
      <div style={{ marginBottom: 8, fontWeight: 600 }}>{title}</div>
      {page.list.length ? (
        <Timeline
          items={page.list.map((item) => ({
            children: (
              <div style={{ paddingBottom: 8 }}>
                <div
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <span>{item.title}</span>
                  <Text type="secondary">{formatCrmDate(item.time)}</Text>
                </div>
                <Text type="secondary">
                  操作人{' '}
                  {item.operatorName ||
                    memberNameMap?.[item.operatorUserUuid || ''] ||
                    item.operatorUserUuid ||
                    '-'}
                </Text>
                {item.description ? (
                  <Paragraph style={{ marginBottom: 0 }}>
                    {item.description}
                  </Paragraph>
                ) : null}
              </div>
            ),
          }))}
        />
      ) : (
        <Empty description={false} />
      )}
    </>
  );
}
